// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2qMiK","secondary":"button_secondary__3806j"};